/**
 * Mutations
 */

export const SET_ALL_ENTRIES = 'Set all entries'
export const SET_MANY_ENTRIES = 'Set many entries'
export const REMOVE_ENTRY = 'Remove entry'
export const SET_ENTRY = 'Set entry'
export const SET_TREE_STACK = 'Set tree stack'

/**
 * Actions
 */

export const FETCH_ENTRIES = 'Fetch entries'
export const FETCH_UPDATES = 'Fetch updates'
export const FETCH_ENTRY = 'Fetch entry'
export const SET_SORT_ORDER = 'Set entry sort order'
export const VAULT_TREE_OPEN = 'Open in vault tree'
export const VAULT_TREE_CLOSE = 'Close vault in tree'
export const VAULT_TREE_CLOSE_ALL = 'Close all vaults in tree'
